module.exports = __webpack_public_path__ + "img/iconTel.dc6631c3.svg";